import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { AuthenticationMessenger } from '@dangl/angular-dangl-identity-client';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'da-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, RouterLink]
})
export class LandingPageComponent {
  private authenticationMessenger = inject(AuthenticationMessenger);

  isAuthenticated = toSignal(this.authenticationMessenger.isAuthenticated, { initialValue: false });
}
